import { DEFAULT_PAGE_SIZE, listUsers, type ManagedUserPage } from '@/api/users'
import { usePagedList, type PagedList } from '@/hooks/usePagedList'

/**
 * Accounts live in Keycloak, which answers in the order it keeps them and takes no column to
 * order by — so this is the one list without sortable headings.
 */
export type UserSort = 'DEFAULT'

export type UserList = PagedList<ManagedUserPage, UserSort> & {
  includeDeleted: boolean
  setIncludeDeleted: (include: boolean) => void
}

const FILTERS = ['deleted'] as const
const DIRECTIONS: Readonly<Record<UserSort, 'ASC'>> = { DEFAULT: 'ASC' }

export function useUserList(): UserList {
  const list = usePagedList<ManagedUserPage, UserSort>({
    filterKeys: FILTERS,
    directions: DIRECTIONS,
    defaultSort: 'DEFAULT',
    initialPageSize: DEFAULT_PAGE_SIZE,
    rowCount: (page) => page.users.length,
    load: ({ search, page, size, filters }, signal) =>
      listUsers({ search, includeDeleted: filters.deleted === 'true', page, size }, signal),
  })

  return {
    ...list,
    includeDeleted: list.filters.deleted === 'true',
    setIncludeDeleted: (include) => list.setFilter('deleted', include ? 'true' : ''),
  }
}
